import { useTranslation } from 'react-i18next';

export interface SkipLinkProps {
  /** id of the target landmark to jump to (without the leading '#'). */
  targetId: string;
}

// Off-screen transform value reused for the hidden state and the blur reset.
const HIDDEN = 'translateY(calc(-100% - var(--s-5)))';

// Keyboard-only "skip to content" link — the first focusable element in the
// app shell. WHY: off-screen until focus, then slides into view so a keyboard
// user can jump past the nav chrome straight to the main landmark; the slide
// honours prefers-reduced-motion via the global transition-duration override.
export function SkipLink({ targetId }: SkipLinkProps) {
  const { t } = useTranslation('common');
  return (
    <a
      href={`#${targetId}`}
      style={{
        position: 'absolute',
        top: 'var(--s-3)',
        left: 'var(--s-3)',
        zIndex: 1000,
        transform: HIDDEN,
        transition: 'transform var(--dur-1) var(--ease-out)',
        padding: 'var(--s-3) var(--s-4)',
        background: 'var(--bg-1)',
        color: 'var(--fg-1)',
        border: '1px solid var(--border-strong)',
        borderRadius: 'var(--r-2)',
        boxShadow: 'var(--shadow-2)',
        fontSize: 'var(--fz-13)',
        fontWeight: 500,
        textDecoration: 'none',
      }}
      onFocus={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
      }}
      onBlur={(e) => {
        e.currentTarget.style.transform = HIDDEN;
      }}
    >
      {t('a11y.skipToContent')}
    </a>
  );
}
